import { useSuspenseQuery } from '@tanstack/react-query'
import { useSessionUser } from '@/hooks/use-session'
import { getRouteApi } from '@tanstack/react-router'
import type { EmployerEntry } from 'shared/types'

const rootApi = getRouteApi('__root__')

const DANCHIANO_ENTRY: EmployerEntry = {
  companyId: null,
  name: "D'Anchiano",
  image: null,
  employeeType: null,
  reevaluate: null,
}

// Active employer for a multi-company employee; the choice lives in the session, so the switcher is global.
export function useActiveEmployer() {
  const user = useSessionUser()
  const isEmployee = user?.type === 'applicant' && user.isEmployee

  // getMyEmployers is authOptional, so this is safe while logged out: anonymous gets [].
  const { data: employers } = useSuspenseQuery(rootApi.useRouteContext().myEmployersQueryOptions)
  // Dropdown only — it can lag the session, so it is not the source of the active employer.
  const companyEmployers: EmployerEntry[] = employers ?? []
  const list: EmployerEntry[] = companyEmployers.length > 0 ? [DANCHIANO_ENTRY, ...companyEmployers] : []
  // From getUser, so the chrome renders atomically with the user; null means the personal profile.
  const activeEmployer = user?.activeEmployer ?? list[0]
  const activeEmployerId = activeEmployer?.companyId ?? null

  return { employers: list, activeEmployer, activeEmployerId, isEmployee }
}
